class InteractiveGraph extends HTMLElement {
    constructor() {
        super()
        this.tooltip = this.querySelector("[data-ig-tooltip]")
        this.tooltipType = this.tooltip.querySelector("[data-aa-type]")
        this.tooltipValue = this.tooltip.querySelector("[data-ig-data-preview]")
        this.bars = this.querySelectorAll("[data-ig-bar]")
        this.activeBar = null
    }

    connectedCallback() {
        this.bars.forEach((bar) => {
            bar.addEventListener("mouseenter", () => this.onEnter(bar))
            bar.addEventListener("mouseleave", () => this.onLeave(bar))
            bar.addEventListener("mousemove", (e) => this.onMove(e))
            bar.addEventListener("click", (e) => this.onTouch(bar, e))
        })

        document.addEventListener("click", (e) => {
            if (!this.contains(e.target)) this.hideTooltip()
        })

        this.setupAnimation()
    }

    setupAnimation() {
        const barEls = this.querySelectorAll("[data-grow-bar]")
        let animated = false
        let cachedHeights = null

        const animate = () => {
            if (animated) return
            animated = true
            if (!cachedHeights) cachedHeights = [...barEls].map((el) => getComputedStyle(el).height)
            gsap.set(barEls, { height: 0 })
            gsap.to(barEls, {
                height: (i) => cachedHeights[i],
                duration: 1.2,
                ease: "smooth",
                stagger: 0.01
            })
        }

        const reset = () => {
            animated = false
            gsap.set(barEls, { height: 0 })
        }

        const drawer = this.closest("side-drawer")
        const openBtn = document.querySelector('[data-drawer-trigger="ig"]')

        if (!openBtn || !drawer) {
            requestAnimationFrame(animate)
            return
        }

        openBtn.addEventListener("click", () => setTimeout(animate, 0))

        const closeBtn = drawer.querySelector('[data-modal="close"]')
        const backdrop = drawer.querySelector('[data-modal="bg"]')
        const onClose = () => setTimeout(reset, 650)
        closeBtn?.addEventListener("click", onClose)
        backdrop?.addEventListener("click", onClose)
    }

    onEnter(bar) {
        if (this.isTouch()) return
        this.showTooltip(bar)
    }

    onLeave(bar) {
        if (this.isTouch()) return
        this.hideTooltip(bar)
    }

    onMove(e) {
        if (this.isTouch()) return
        this.positionTooltip(e.clientX, e.clientY)
    }

    onTouch(bar, e) {
        if (!this.isTouch()) return

        e.stopPropagation()

        if (this.activeBar === bar) {
            this.hideTooltip(bar)
            this.activeBar = null
            return
        }

        if (this.activeBar) {
            const prevBg = this.activeBar.firstElementChild
            if (prevBg) prevBg.classList.add("hidden")
        }

        this.activeBar = bar
        this.showTooltip(bar)

        const barRect = bar.getBoundingClientRect()
        const parentRect = this.tooltip.parentElement.getBoundingClientRect()

        const tooltipHeight = this.tooltip.offsetHeight
        const tooltipWidth = this.tooltip.offsetWidth

        let x = barRect.left + barRect.width / 2 - parentRect.left - tooltipWidth / 2
        let y = barRect.top - parentRect.top - tooltipHeight - 8

        x = Math.max(0, Math.min(x, parentRect.width - tooltipWidth))
        y = Math.max(0, Math.min(y, parentRect.height - tooltipHeight))

        gsap.set(this.tooltip, { x, y })
    }

    positionTooltip(clientX, clientY) {
        const rect = this.tooltip.parentElement.getBoundingClientRect()
        const tooltipRect = this.tooltip.getBoundingClientRect()

        const cursorX = clientX - rect.left
        const cursorY = clientY - rect.top

        const spaceRight = rect.width - cursorX
        const spaceBottom = rect.height - cursorY

        let x =
            spaceRight < tooltipRect.width
                ? cursorX - tooltipRect.width
                : cursorX

        let y =
            spaceBottom < tooltipRect.height
                ? cursorY - tooltipRect.height
                : cursorY

        gsap.to(this.tooltip, {
            x,
            y,
            duration: 0.5,
            ease: "power2.out"
        })
    }

    showTooltip(bar) {
        const value = bar.dataset.igBar
        const type = bar.dataset.aa

        this.tooltip.hidden = false
        this.tooltipType.textContent = type
        this.tooltipValue.textContent = value

        const bg = bar.firstElementChild
        if (bg) bg.classList.remove("hidden")
    }

    hideTooltip(bar = this.activeBar) {
        this.tooltip.hidden = true

        if (bar) {
            const bg = bar.firstElementChild
            if (bg) bg.classList.add("hidden")
        }
    }

    isTouch() {
        return window.matchMedia("(pointer: coarse)").matches
    }
}

customElements.define("interactive-graph", InteractiveGraph)